import useSWR from "swr"
import {API_TEAMS} from "../constants/apiUrls"

export default function useTeams() {
    const {data, mutate, error} = useSWR(`${API_TEAMS}?limit=100`)
    return {
        teams: data?.sort((a, b) => a.name.localeCompare(b.name)),
        mutateTeams: mutate,
        isLoadingTeams: !error && !data,
        isErrorTeams: error
    }
}